import React from "react";
import styles from "./custom-timepicker.module.css";
import { TimePicker, Typography } from "antd";

const CustomTimePicker = ({
  label,
  showRequired,
  labelColor,
  showOptional,
  value,
  onChange,
  onBlur,
  errorMessage,
  size = "large",
  style = { width: "100%" },
  placeholder = "Select Time",
  prefix,
  suffixIcon = null,
  disabled = false,
  status,
  format = "HH:mm:ss",
}) => {
  return (
    <div>
      {label ? (
      <div style={{ marginBottom: 8, fontWeight: 400, color: labelColor }}>
        {label}
        {showRequired ? (
          <span style={{ color: "red" }}>*</span>
        ) : showOptional ? (
          <span style={{ color: "#8C8C8C" }}>
            {typeof showOptional === "string"
              ? ` ${showOptional}`
              : " (Optional)"}
          </span>
        ) : null}
      </div>
      ) : null}
      <TimePicker
        style={style}
        placeholder={placeholder}
        size={size}
        value={value}
        onChange={onChange}
        onBlur={onBlur} 
        disabled={disabled}
        suffixIcon={suffixIcon}
        prefix={prefix}
        format={format}
        status={status}
      />
      <Typography.Text type="danger" style={{ marginTop: 5 }}>
        {errorMessage}
      </Typography.Text>
    </div>
  );
};

export default CustomTimePicker;
